import React, { Component } from 'react';
import axios from "axios";
import API from "../../API";
import './success-page.css';
import {Helmet} from "react-helmet";
import Main from "../../layout/main";
import {Col, Container, Row} from "reactstrap";

class SuccessPage extends Component {
    constructor(props) {
        super(props);
        const id = this.props.match.params.id;
        this.state = {
            id: id,
            projectType: '',
            projectData: [],
            openItemIndex: null,
            showAlert: false,
            providerId: null,
            providerName: '',
            loadingShow: false
        };
    }

    getQueryParams(param) {
        const params = new URLSearchParams(this.props.location.search);
        return params.get(param);
    }
    
    componentWillMount() {
        this.getServiceProviderData();
    }

    getServiceProviderData = () => {
        this.setState({loadingShow: true});
        const projectType = this.getQueryParams('project_type');
        axios.get(API.baseURL + `/services/${projectType}/:zip_code?project_id=${this.props.match.params.id}`, API.options)
            .then((response) => response.data)
            .then((res) => {
                this.setState({
                    loadingShow: false,
                    projectData: res,
                    projectType: projectType
                });
            }).catch((err) => {
                this.setState({loadingShow: false});
                console.error("Error loading providers:", err);
            });
    }

    leadPurchase = (idProvider) => {
        this.setState({loadingShow: true});
        const leadObj = {
            is_customer_purchased: true,
            provider_id: idProvider,
            payment_type: 'debit',
            project_id: this.props.match.params.id,
        };
        
        axios.post(API.baseURL + `/v2/providers/lead_purchased_by_customer`, leadObj, API.options)
            .then((result) => {
                const data = JSON.stringify({
                    payment_type: "debit",
                    category: "Lead Contact Purchase",
                    project_id: this.props.match?.params?.id,
                    wallet_history_id: result?.data?.history?.id,
                    is_customer_purchased: true,
                    provider_id: idProvider
                });
                
                axios.post(API.baseURL + `/v2/providers/projects/${this.props.match?.params?.id}/lead_purchased`, data, API.options)
                    .then(() => {
                        this.getServiceProviderData();
                    }).catch((err) => {
                        alert(err.message);
                        this.setState({loadingShow: false});
                    });
            }).catch((err) => {
                this.setState({loadingShow: false});
                alert(err.response?.data?.error || "An error occurred");
            });
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
      
        return `${day}/${month}/${year}`;
    }

    toggleItem = (index) => {
        this.setState((prevState) => ({
            openItemIndex: prevState.openItemIndex === index ? null : index,
        }));
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>EasyBids - Home Improvements :: Your Project is Live!</title>
                </Helmet>
                <Main additionalClass_main="dashboard pt-0">
                    <section className="ebw-section__pages">
                        <Container>
                            <Row>
                                <Col xl={{size: 6, offset: 3}}>
                                    <div className="success-message-card">
                                        <div className="icon-container-popup">
                                            <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <rect width="52" height="52" rx="26" fill="#28a745"
                                                      fillOpacity="1"/>
                                                <path d="M35.3334 19L22.5 31.8333L16.6667 26" stroke="white"
                                                      strokeWidth="2"
                                                      strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <div className="success-message-content">
                                            <h2 className="success-message-title" style={{fontSize: '20px'}}>You
                                                have
                                                successfully posted your project</h2>
                                            <p className="success-message-subtitle" style={{fontSize: '14px'}}>
                                                We have notified local Service Providers about your project.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={{size: 6, offset: 3}}>
                                    {this.state.projectData?.length > 0 && (
                                        <div className="provider-section">
                                            {/* Header */}
                                            <div className="provider-section-header">
                                                <h2 className="provider-section-title">NEED A SERVICE PROVIDER
                                                    NOW?</h2>
                                                <div className="provider-section-subtitle-container">
                                                    <p className="provider-section-subtitle">
                                                        Don't wait! Choose from our top-qualified service providers
                                                        below
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Provider List */}
                                            <div className="provider-list">
                                                <Row>
                                                    <Col>
                                                        {this.state.projectData?.map((provider, index) => (
                                                            <div key={provider?.id} className="provider-card">
                                                                <div className="provider-header">
                                                                    <div className="provider-avatar">
                                                                        <img src={provider?.image_url}
                                                                             alt={provider?.name}/>
                                                                    </div>
                                                                    <div className="provider-info">
                                                                        <div className="provider-name-container">
                                                                            <p className="provider-name">{provider?.name}</p>
                                                                            {provider?.is_pro_provider && (
                                                                                <span
                                                                                    className="pro-badge">PRO +</span>
                                                                            )}
                                                                        </div>
                                                                        <p className="provider-rating">
                                                                            <span className="rating-badge">
                                                                                {provider?.average_reviews} <span
                                                                                className="star">★</span>
                                                                            </span>
                                                                            {provider?.total_reviews}{' ratings'}{' '}
                                                                            <span
                                                                                className="experience">{provider?.experience}+ years</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="provider-badges">
                                                                    {provider?.have_insurance && (
                                                                        <div className="badge">
                                                                            <img
                                                                                src="/assets/icon/credit-card-edit.svg"
                                                                                alt="Insurance"/>
                                                                            Insured
                                                                        </div>
                                                                    )}
                                                                    {provider?.have_license && (
                                                                        <div className="badge">
                                                                            <img
                                                                                src="/assets/icon/credit-card-edit.svg"
                                                                                alt="License"/>
                                                                            Licensed
                                                                        </div>
                                                                    )}
                                                                </div>


                                                                {provider?.phone_number ? (
                                                                    <>
                                                                        <div className="contact-buttons">
                                                                            <button
                                                                                onClick={() => {
                                                                                    window.location.href = `tel:${provider?.phone_number}`
                                                                                }}
                                                                                className="call-button"
                                                                            >
                                                                <span
                                                                    className="phone-number">{provider?.phone_number}</span>
                                                                                <span><img alt="Call"
                                                                                           src="/images/projects/icons/call.svg"
                                                                                           width="14"/></span>
                                                                            </button>

                                                                            <button
                                                                                onClick={() => {
                                                                                    window.location.href = `sms:${provider?.phone_number}?&body=I found your profile on EasyBids and want to discuss my project with you.`
                                                                                }}
                                                                                className="sms-button"
                                                                            >
                                                                                SMS
                                                                            </button>

                                                                            <button
                                                                                onClick={() => {
                                                                                    window.location.href = `mailto:${provider?.email}?subject=Project Inquiry&body=I found your profile on EasyBids and want to discuss my project with you`
                                                                                }}
                                                                                className="email-button"
                                                                            >
                                                                                Email
                                                                            </button>
                                                                        </div>

                                                                        <p className="contact-notice">
                                                                            Your phone number has been shared with
                                                                            the Service
                                                                            Provider
                                                                        </p>
                                                                    </>
                                                                ) : (
                                                                    <button
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                showAlert: true,
                                                                                providerName: provider?.name,
                                                                                providerId: provider?.id
                                                                            });
                                                                        }}
                                                                        className="contact-provider-button"
                                                                    >
                                                                        Contact Service Provider
                                                                    </button>
                                                                )}

                                                                <button
                                                                    onClick={() => this.toggleItem(index)}
                                                                    className="toggle-details-button"
                                                                >
                                                                    <span
                                                                        className="mr-2">Services offered & customer reviews</span>
                                                                    <svg
                                                                        className={`toggle-icon ${this.state.openItemIndex === index ? 'rotated' : ''}`}
                                                                        width="15"
                                                                        height="12"
                                                                        viewBox="0 0 15 12"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M7.5 12L0 0L15 0L7.5 12Z"
                                                                            fill="#3e84fb"
                                                                        />
                                                                    </svg>
                                                                </button>

                                                                {this.state.openItemIndex === index && (
                                                                    <div className="provider-details">
                                                                        <div className="services-section">
                                                                            <div className="services-content">
                                                                                <h2 className="services-title">Services
                                                                                    Offered</h2>
                                                                                <p className="services-list">
                                                                                    {provider?.categories.map((item, index) => (
                                                                                        <React.Fragment
                                                                                            key={item.id}>
                                                                                            {item?.title}
                                                                                            {index !== provider.categories.length - 1 && ', '}
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="reviews-section">
                                                                            <div className="customer-reviews"
                                                                                 style={{
                                                                                     display: 'flex',
                                                                                     justifyContent: 'space-between'
                                                                                 }}>
                                                                                <p className="reviews-title ml-0">Customer
                                                                                    Reviews</p>
                                                                                <p className="reviews-summary"
                                                                                   style={{fontSize: '14px'}}>
                                                                <span className="rating-badge"
                                                                      style={{fontSize: '14px'}}>
                                                                    {provider?.average_reviews} <span
                                                                    className="star">★</span>
                                                                </span>
                                                                                    {provider?.total_reviews}{' ratings'}
                                                                                </p>
                                                                            </div>

                                                                            {provider?.feedbacks.map((review) => (
                                                                                <div className="review-card"
                                                                                     key={review?.id}>
                                                                                    <div className="review-header">
                                                                                        <div
                                                                                            className="reviewer-info">
                                                                                            <img
                                                                                                src={review?.consumer_avatar_url}
                                                                                                alt="Reviewer"
                                                                                                className="reviewer-img"/>
                                                                                            <div>
                                                                                                <p className="reviewer-name">{review?.consumer_name}</p>
                                                                                                <p className="review-rating">
                                                                                                    {review?.ratings}
                                                                                                    <span
                                                                                                        className="star">★</span>
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="review-time">{this.formatDate(review?.created_at)}</div>
                                                                                    </div>
                                                                                    <div className="review-body">
                                                                                        <p>{review?.description}</p>
                                                                                        <a href="javascript:void(0)"
                                                                                           className="project-category">Project
                                                                                            Category: </a>
                                                                                        <span>{review?.project_type}</span>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    )}

                                    {/* No providers message */}
                                    {this.state.projectData?.length === 0 && !this.state.loadingShow && (
                                        <div className="no-providers">
                                            <p>No service providers found for this project type. We're notifying
                                                local providers
                                                about your project.</p>
                                            <button
                                                onClick={() => this.props.history.push('/my-projects')}
                                                className="go-back-button"
                                            >
                                                Go to My Projects
                                            </button>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    {this.state.showAlert && (
                                        <div className="alert-overlay">
                                            <div className="alert-dialog">
                                                <h3>Contact Service Provider</h3>
                                                <p>Confirm now to see the contact details for {this.state.providerName}.
                                                    This will also
                                                    send your contact details to the provider so they can also contact
                                                    you.</p>
                                                <div className="alert-buttons">
                                                    <button
                                                        onClick={() => this.setState({showAlert: false})}
                                                        className="cancel-button"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            this.setState({showAlert: false});
                                                            this.leadPurchase(this.state.providerId);
                                                        }}
                                                        className="confirm-button"
                                                    >
                                                        Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.loadingShow && (
                                        <div className="loading-overlay">
                                            <div className="spinner"></div>
                                            <p>Loading...</p>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Main>
            </div>
        );
    }
}

export default SuccessPage;